"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTerminalSettingsUpdate = exports.useTerminalSettingsCreate = exports.useTerminalSettingsFetch = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const terminalSettingsAction_1 = require("./terminalSettingsAction");
const useTerminalSettingsFetch = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const terminalSettingsFetchLoading = (0, react_redux_1.useSelector)((state) => state["terminalSettings/fetch"].loading);
    const terminalSettingsFetchError = (0, react_redux_1.useSelector)((state) => state["terminalSettings/fetch"].error);
    const terminalSettingsFetchData = (0, react_redux_1.useSelector)((state) => state["terminalSettings/fetch"].data);
    const terminalSettingsFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLoggedIn) {
            history("/login");
            return;
        }
        yield dispatch((0, terminalSettingsAction_1.fetch)(payload));
    });
    return {
        terminalSettingsFetchLoading,
        terminalSettingsFetchError,
        terminalSettingsFetchData,
        terminalSettingsFetch
    };
};
exports.useTerminalSettingsFetch = useTerminalSettingsFetch;
const useTerminalSettingsCreate = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const terminalSettingsCreateLoading = (0, react_redux_1.useSelector)((state) => state["terminalSettings/create"].loading);
    const terminalSettingsCreateError = (0, react_redux_1.useSelector)((state) => state["terminalSettings/create"].error);
    const terminalSettingsCreateData = (0, react_redux_1.useSelector)((state) => state["terminalSettings/create"].data);
    const terminalSettingsCreate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLoggedIn) {
                history("/login");
                return;
            }
            const res = yield dispatch((0, terminalSettingsAction_1.create)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
                return;
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Failed to create terminal settings");
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        terminalSettingsCreateLoading,
        terminalSettingsCreateError,
        terminalSettingsCreateData,
        terminalSettingsCreate
    };
};
exports.useTerminalSettingsCreate = useTerminalSettingsCreate;
const useTerminalSettingsUpdate = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const terminalSettingsUpdateLoading = (0, react_redux_1.useSelector)((state) => state["terminalSettings/update"].loading);
    const terminalSettingsUpdateError = (0, react_redux_1.useSelector)((state) => state["terminalSettings/update"].error);
    const terminalSettingsUpdateData = (0, react_redux_1.useSelector)((state) => state["terminalSettings/update"].data);
    const terminalSettingsUpdate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLoggedIn) {
                history("/login");
                return;
            }
            const res = yield dispatch((0, terminalSettingsAction_1.update)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
                return;
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Failed to update terminal settings");
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        terminalSettingsUpdateLoading,
        terminalSettingsUpdateError,
        terminalSettingsUpdateData,
        terminalSettingsUpdate
    };
};
exports.useTerminalSettingsUpdate = useTerminalSettingsUpdate;
